export default __webpack_public_path__ + "static/media/googleauthenticator.a484b6ca.png";